"use strict";

var PyDefUtils = require("PyDefUtils");
var utils = require("../utils");
const { getCssPrefix } = require("@runtime/runner/legacy-features");

var generateOutlineGuidelines = function(element) {
    var innerTop = element.offset().top + parseFloat(element.css("padding-top"));

    return [
        {x1:element.offset().left, y1: innerTop,
         x2:element.offset().left + element.outerWidth(), y2: innerTop},
        {x1:element.offset().left + element.outerWidth(), y1: innerTop,
         x2:element.offset().left + element.outerWidth(), y2: innerTop + element.height()},
        {x1:element.offset().left, y1: innerTop + element.height(),
         x2:element.offset().left + element.outerWidth(), y2: innerTop + element.height()},
        {x1:element.offset().left, y1: innerTop,
         x2:element.offset().left, y2: innerTop + element.height()},
    ];
}

module.exports = function(pyModule) {

    pyModule["DesignDataGrid"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {
        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            Sk.misceval.call(pyModule["DataGrid"].prototype["__init__"], undefined, undefined, kwargs, self);

            let h = $("<div/>").addClass("anvil-designer-data-grid-config-header anvil-data-row-panel");

            self._anvil.updateConfigHeader = () => {
                h.empty();
                for (let col of self._anvil.getPropJS("columns") || []) {
                    h.append($("<div/>").addClass(`${getCssPrefix()}data-row-col`)
                                        .attr("data-grid-id", self._anvil.dataGridId)
                                        .attr("data-grid-col-id", col.id)
                                        .append($("<div/>").addClass("anvil-designer-col-width-prompt"))
                                        .append($("<div/>").addClass("anvil-designer-col-overlay")));
                }
            }
            self._anvil.updateConfigHeader();
            self._anvil.element.prepend(h);
            self._anvil.elements.configHeader = h[0];
            
            self._anvil.whereWillItLand = function(_x, _y, _width, _height, mouseX, mouseY, pyMovingComponent) {

                let footerSlot = self._anvil.element.find(`.${getCssPrefix()}footer-slot`);
                let footerSlotOffset = footerSlot.offset();
                let rtn = {};

                if (mouseX > footerSlotOffset.left
                 && mouseX < footerSlotOffset.left + footerSlot.width()
                 && mouseY > footerSlotOffset.top
                 && mouseY < footerSlotOffset.top + footerSlot.height()
                 && (self._anvil.components || []).filter(c => c.layoutProperties.slot == "footer").length == 0) {

                    rtn = {
                        childIdx: (self._anvil.components || []).length, 
                        layoutProperties: { slot: "footer" },
                        estimatedPosition: utils.positionOf(footerSlot, 0),
                        estimatedPositionContainer: utils.positionOf(self._anvil.element, 2),
                    };
                } else {
                    let childIdx = 0;
                    let suggestedPos = footerSlot.top;

                    let tops = self._anvil.childPanel.find(`>:not(.${getCssPrefix()}auto-grid-header)`)
                        .map((_,e) => $(e).offset().top);

                    for (let i = 0; i < tops.length; i++) {
                        let t = tops[i];
                        let t2 = tops[i+1] || footerSlot.offset().top;
                        let t3 = (t + t2) / 2;

                        childIdx = i + (mouseY > t3 ? 1 : 0);
                        suggestedPos = mouseY > t3 ? t2 : t;

                        if (mouseY < t3) {
                            break;
                        }
                    }

                    // TODO: Cope with moving an element below itself.

                    rtn = {
                        childIdx: childIdx, 
                        layoutProperties: { slot: undefined },
                        estimatedPosition: {x: this.childPanel.offset().left, y: suggestedPos,
                                            width: this.childPanel.outerWidth(), height: 0},
                        estimatedPositionContainer: utils.positionOf(self._anvil.element, 2),
                    };
                }

                let [distance, nearest] = utils.distanceToEdge(self._anvil.element, mouseX, mouseY);
                if (distance < Math.min(15, self._anvil.element.outerHeight() / 3)) {
                    rtn.redirectToElement = self._anvil.element.parent().closest(".anvil-container");
                }

                return rtn;

            }

            const getHandles = function(pyChild) {
                var handles = [];

                if (pyChild) {
                    // Get layout handles for pyChild
                    // DataGrid doesn't provide any.
                } else {
                    // Get our own handles

                    var cols = self._anvil.element.find(`>.anvil-designer-data-grid-config-header>.${getCssPrefix()}data-row-col`);//.filter((i, e)  => $(e).next().length);

                    cols.each(function(i,c) {
                        c = $(c);
                        var offset = c.offset();
                        let label = undefined;
                        handles.push({
                            colId: c.attr("data-grid-col-id"),

                            // I would love to use c.outerWidth() here, as we do in DesignColumnPanel,
                            // but there is a bug in jQuery, in Chrome, for elements with padding, when
                            // zoomed to 110%, that causes outerWidth() to count the padding twice.
                            //
                            // I am not kidding.
                            //
                            // I wish I was.
                            x: offset.left + c[0].clientWidth - 1,

                            y: offset.top+2,
                            width: 2,
                            height: Math.max(self._anvil.element.height() - self._anvil.footerSlot.parent().outerHeight() - 4, 15),
                            cursor: "ew",
                            owner: self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : self._anvil.componentSpec?.name,
                            showOnChildHover: false,
                            label: label,
                        })
                    });
                }

                return handles;
            };
            const handleGrab = function(handle, mouseX, mouseY) {
                self._anvil.element.find(`>.anvil-designer-data-grid-config-header`).addClass("adjusting");
                var col = self._anvil.element.find(`>.anvil-designer-data-grid-config-header>.${getCssPrefix()}data-row-col[data-grid-col-id=${handle.colId}]`);

                let cols = self._anvil.getPropJS("columns");
                let colSpec = null;
                for (let c of cols || []) {
                    if (c.id == handle.colId) {
                        colSpec = c;
                        break;
                    }
                }

                self._anvil.element.find(`>.anvil-designer-data-grid-config-header>.${getCssPrefix()}data-row-col`).each((i,e) => {
                    if (cols[i].width != null) {
                        $(e).find(".anvil-designer-col-width-prompt").css("display", "block").addClass("anvil-designer-fixed-width-column").text(`${Math.round($(e).outerWidth())} px`);
                    } else {
                        $(e).find(".anvil-designer-col-width-prompt").css("display", "block").removeClass("anvil-designer-fixed-width-column").html("&#8621");
                    }
                    if (cols[i].id == handle.colId) {
                        $(e).find(".anvil-designer-col-overlay").height(self._anvil.element.height()).css("display", "block");
                    }
                });

                return {
                    mouseX: mouseX,
                    mouseY: mouseY,
                    colWidth: col[0].clientWidth, // See comment in getHandles, above.
                };
            };

            const handleDrag = function(handle, grab, mouseX, mouseY, metaKey) {

                var col = self._anvil.element.find(`>.anvil-designer-data-grid-config-header>.${getCssPrefix()}data-row-col[data-grid-col-id=${handle.colId}]`);

                let cols = self._anvil.getPropJS("columns");
                let colSpec = null;
                for (let c of cols || []) {
                    if (c.id == handle.colId) {
                        colSpec = c;
                        break;
                    }
                }

                colSpec.width = grab.colWidth + (mouseX - grab.mouseX);
                colSpec.expand = false;

                self._anvil.element.find(`>.anvil-designer-data-grid-config-header>.${getCssPrefix()}data-row-col`).each((i,e) => {
                    if (cols[i].width != null) {
                        $(e).find(".anvil-designer-col-width-prompt").css("display", "block").addClass("anvil-designer-fixed-width-column").text(`${Math.round($(e).outerWidth())} px`);
                    } else {
                        $(e).find(".anvil-designer-col-width-prompt").css("display", "block").removeClass("anvil-designer-fixed-width-column").html("&#8621");
                    }
                });

                self._anvil.updateColStyles(cols);

                handle.x = col.offset().left + col[0].clientWidth - 1; // See comment in getHandles, above.
                return handle;
            };

            const prepareHandleDrop = function(handle, grab, mouseX, mouseY) {
                self._anvil.element.find(`>.anvil-designer-data-grid-config-header`).removeClass("adjusting");

                self._anvil.element.find(`>.anvil-designer-data-grid-config-header>.${getCssPrefix()}data-row-col`).each((i, e) => {
                    $(e).find(".anvil-designer-col-width-prompt").css("display", "none");
                    $(e).find(".anvil-designer-col-overlay").css("display", "none");
                });

                if (mouseX == grab.mouseX) {
                    return;
                }

                return {colId: handle.colId, width: grab.colWidth + (mouseX - grab.mouseX), expand: false};
            }

            const handleDrop = function(handle, grab, mouseX, mouseY) {

                const {colId, width} = prepareHandleDrop(handle, grab, mouseX, mouseY) || {};
                if (!colId) { return; }

                let cols = self._anvil.getPropJS("columns");
                let colSpec = null;
                for (let c of cols || []) {
                    if (c.id == colId) {
                        colSpec = c;
                        break;
                    }
                }
                colSpec.width = width;
                colSpec.expand = false;

                let selfName = self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : self._anvil.componentSpec?.name;
                let r = { 
                    properties: {
                        [selfName]: { columns: cols },
                    }
                };

                return r;
            }

            const prepareHandleDoubleClick = function(handle) {
                self._anvil.element.find(`>.anvil-designer-data-grid-config-header>.${getCssPrefix()}data-row-col`).each((i,e) => {
                    $(e).find(".anvil-designer-col-width-prompt").css("display", "none");
                });
                return {colId: handle.colId, width: undefined}
            };

            const handleDoubleClick = function(handle) {
                const {colId} = prepareHandleDoubleClick(handle);

                let cols = self._anvil.getPropJS("columns");
                let colSpec = null;
                for (let c of cols || []) {
                    if (c.id == colId) {
                        colSpec = c;
                        break;
                    }
                }
                delete colSpec.width;

                let selfName = self._anvil.element.hasClass("anvil-designer-component-namespace") ? "" : self._anvil.componentSpec?.name;
                let r = { 
                    properties: {
                        [selfName]: { columns: cols },
                    }
                };
                return r;
            }

            Object.assign(self._anvil, {getHandles, handleGrab, handleDrag, handleDrop, handleDoubleClick});
            self._anvil.handleHooks = {getHandles, handleGrab, handleDrag, prepareHandleDrop, prepareHandleDoubleClick};
            self.tp$setattr(new Sk.builtin.str("_anvil_private_handle_hooks"), Sk.ffi.toPy(self._anvil.handleHooks));
        }));


    }, 'DesignDataGrid', [pyModule["DataGrid"]]);
};
